import React, { useState } from "react";
import { UseQueryResult } from "@tanstack/react-query";
import { mergeStyles } from "@fluentui/merge-styles";

const wrapperClasses = mergeStyles({
  padding: 5,
  marginBottom: 20,
  border: "1px solid red",
});

type Props = {
  query: UseQueryResult;
  refetch: () => Promise<any>;
  title: string;
};

const QueryDebug: React.FC<Props> = (props) => {
  const { query, title, refetch } = props;

  const [details, setDetails] = useState<boolean>(false);

  return (
    <div className={wrapperClasses}>
      <h5>
        {title} status: {query.status}
      </h5>
      <div>
        <button
          onClick={() => {
            setDetails((state) => !state);
          }}
        >
          Details
        </button>
      </div>
      <div>
        <button onClick={refetch}>Refetch</button>
        {query.isRefetching && <div>Refetching...</div>}
      </div>
      {details && <pre>{query ? JSON.stringify(query, null, 4) : null}</pre>}
    </div>
  );
};

export default QueryDebug;
